module.exports = __webpack_public_path__ + "img/backgroundImg.af617626.jpg";